import {
  LocationRecommendationsLevel,
  LocationRecommendationsLevelHelper,
  ModelType,
  PostAddUpsellType,
  PostAddUpsellTypeHelper,
  RecommendationExperimentType,
  RecommendationExperimentTypeHelper,
} from '@biteinc/enums';
import { recommendationVariationSchema } from '@biteinc/schemas';

app.RecommendationVariation = app.AbstractModel.extend({
  ModelName: 'recommendationVariation',
  Schema: recommendationVariationSchema,
  Type: ModelType.RecommendationVariation,

  defaults() {
    return {
      recommendationRuleIds: [],
      experimentType: RecommendationExperimentType.None,
      postAddUpsell: [],
    };
  },

  url() {
    return `/api/v2/recommendation-variations/${this.id || ''}`;
  },

  getFieldCollection(field, subProperty, _includeAllValues, _keyModel) {
    const fieldName = (subProperty ? `${subProperty}.` : '') + field;
    switch (fieldName) {
      case 'recommendationRuleIds':
      case 'experimentRuleIds':
        return app.recommendationRuleList;
      case 'experimentType':
        return app.AbstractCollection.createFromTsEnum({
          tsEnum: RecommendationExperimentType,
          nameGenerator: RecommendationExperimentTypeHelper.name,
        });
      case 'recommendationsLevel':
        return app.AbstractCollection.createFromTsEnum({
          tsEnum: LocationRecommendationsLevel,
          nameGenerator: (level) => {
            return LocationRecommendationsLevelHelper.name(level);
          },
        });
      case 'postAddUpsell.modifierMagicCopyKey':
        const modsByMagicCopyKey = app.modList.models.reduce((acc, mod) => {
          if (mod.get('priceOptions').length > 1) {
            return acc;
          }
          if (!acc[mod.get('magicCopyKey')]) {
            acc[mod.get('magicCopyKey')] = mod;
          }
          return acc;
        }, {});

        return new app.AbstractCollection(
          Object.values(modsByMagicCopyKey).map((mod) => ({
            _id: mod.get('magicCopyKey'),
            name: mod.displayName(),
          })),
        );
      case 'postAddUpsell.menuItemIds':
        return app.menuItemList;
      case 'postAddUpsell.sectionIds':
        return app.menuSectionList;
      case 'postAddUpsell.type':
        return app.AbstractCollection.createFromTsEnum({
          tsEnum: PostAddUpsellType,
          nameGenerator: PostAddUpsellTypeHelper.name,
        });
    }
    return null;
  },

  detailsViewClassForListField(field) {
    switch (field) {
      case 'recommendationRuleIds':
      case 'experimentRuleIds':
        return app.RecommendationRuleDetailsView;
    }
  },
});
